<script lang="ts">
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import ActionItem from "@components/Actions/ActionItem.svelte";
    import ActionsList from "@components/Actions/ActionsList.svelte";
    import ActionsPopover from "@components/Actions/ActionsPopover.svelte";
    import Button from "@components/Buttons/Button.svelte";
    import Icon from "@components/Icon.svelte";
    import SortIcon from "@components/icons/SortIcon.svelte";
    import T from "@components/T.svelte";

    export let currentSortValue: string;
    export let showSort = true;
    export let sortItems: {
        value: string;
        labelTranslationKey: string;
        labelTranslationNamespace: string;
    }[];

    let popoverOpen = false;

    let close: () => void;

    const dispatch = createEventDispatcher();

    const handleClick = (value: string) => {
        dispatch("sortItems", { value });
        close();
    };

    const handleOpenPopover = () => (popoverOpen = true);
    const handleClosePopover = () => (popoverOpen = false);

    $: currentSort = sortItems.find((f) => f.value === currentSortValue);
</script>

{#if showSort}
    <ActionsPopover
        bind:close
        on:open={handleOpenPopover}
        on:close={handleClosePopover}
    >
        <Button
            size="large"
            class="gw-sort-activator"
            variant="text"
            slot="activator"
        >
            <span class="gw-sort-activator__current">
                <slot />
            </span>
            <span class="gw-sort-activator__label-text">
                <T
                    namespace={currentSort?.labelTranslationNamespace || ""}
                    translationKey={currentSort?.labelTranslationKey || ""}
                />
            </span>
            <div
                class={CN("gw-sort__icon", {
                    "gw-sort__icon-open": popoverOpen,
                })}
            >
                <Icon>
                    <SortIcon />
                </Icon>
            </div>
        </Button>
        <ActionsList>
            {#each sortItems as item}
                <ActionItem on:click={() => handleClick(item.value)}>
                    <span class="gw-sort__item-text">
                        <T
                            namespace={item.labelTranslationNamespace}
                            translationKey={item.labelTranslationKey}
                        />
                    </span>
                </ActionItem>
            {/each}
        </ActionsList>
    </ActionsPopover>
{/if}

<style lang="postcss">
    :global(.gw-btn.gw-sort-activator) {
        display: flex;
        gap: 0.5em;
    }

    .gw-sort-activator__current {
        font-weight: 400;
    }

    .gw-sort-activator__label-text {
        font-weight: 600;
        font-size: 1em;
    }

    .gw-sort {
        &__icon {
            transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        }
        &__icon-open {
            transform: rotate(180deg);
        }
    }
</style>
